module.exports = __webpack_public_path__ + "b94128c99706698b8caad62ccf888535.svg";